module.exports = __webpack_public_path__ + "img/reach.2d1a6713.jpg";